import { WidthVariant } from '../../Blocks/WidthVariant.csharp';
import { ProductListViewModel } from './ProductListViewModel.csharp';

export class ProductListUtils {
    private readonly _maxProductsInRow = 5;
    private readonly _model: ProductListViewModel;

    constructor(model: ProductListViewModel) {
        this._model = model;
    }

    public GetVisibleProductsCount = (): [number, number, number] => {
        const { maxProductsAmountOnMobile, maxProductsAmountOnDesktop, maxProductsAmountOnTablet } = this._model;

        return [
            this.getMaxProductsValue(maxProductsAmountOnMobile),
            this.getMaxProductsValue(maxProductsAmountOnTablet),
            this.getMaxProductsValue(maxProductsAmountOnDesktop)
        ];
    };

    public ShouldBeCentered = () => {
        const leadingInfoWidth = this.layoutToWidth(this._model.leadingContent?.layout ?? 0);
        const moreInfoWidth = this.layoutToWidth(this._model.moreInfoContent?.layout ?? 0);
        const totalWidth = this._model.products?.length + leadingInfoWidth + moreInfoWidth;

        return !this._model.moreInfoContent || totalWidth < this._maxProductsInRow;
    };

    private getMaxProductsValue = (value: number) => {
        return value > 0 ? value : this._model.products.length;
    };

    private layoutToWidth = (layout: WidthVariant) => {
        switch (layout) {
            case WidthVariant.OneColumn:
                return 1;
            case WidthVariant.TwoColumn:
                return 2;
            default:
                return 0;
        }
    };
}
